var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-a3e8add4"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "items-center flex flex-col w-full px-16" };
var _hoisted_2 = { class: "relative" };
var _hoisted_3 = { class: "text-xl font-medium mt-6" };
var _hoisted_4 = { class: "mt-4 flex items-center space-x-2.5" };
var _hoisted_5 = { class: "font-medium" };
var _hoisted_6 = { class: "ml-2.5" };
var _hoisted_7 = {
    key: 1,
    class: "mt-7 text-center"
};
var _hoisted_8 = {
    key: 2,
    class: "mt-10 gap-x-2.5 gap-y-2.5 sm:gap-y-0 flex flex-wrap sm:flex-nowrap items-center justify-center"
};
var _hoisted_9 = ["href"];
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, " VK ", -1); });
var _hoisted_11 = ["href"];
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, " Telegram ", -1); });
var _hoisted_13 = { class: "flex items-center space-x-1" };
var _hoisted_14 = { class: "w-4 h-4 mr-2 flex items-center justify-center" };
var _hoisted_15 = {
    key: 0,
    class: "h-4 w-4 rounded-full"
};
var _hoisted_16 = ["href"];
var _hoisted_17 = {
    key: 1,
    class: "inline-block h-2 w-2 rounded-full bg-gray opacity-30"
};
import { computed, ref, toRefs } from 'vue';
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import clipboardCopy from '@common/utils/Clipboard';
import PassData from '@common/utils/PassData';
import { getCountryByPhone, getPhoneMask } from '@common/ui/EInputPhone/utils';
import { countries } from '@common/utils/Location';
import { ChatStore, EmployeeCardStore } from '@common/stores';
import ETooltip from '@common/ui/ETooltip.vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CEmployeeCard',
    setup: function (__props) {
        var t = useI18n().t;
        var _a = toRefs(EmployeeCardStore), visible = _a.visible, hide = _a.hide, employee = _a.employee, loading = _a.loading, isChatHide = _a.isChatHide;
        var showGoToChat = computed(function () {
            var _a, _b, _c;
            var currentUserId = (_a = PassData === null || PassData === void 0 ? void 0 : PassData.user) === null || _a === void 0 ? void 0 : _a.id;
            return currentUserId !== ((_b = employee.value) === null || _b === void 0 ? void 0 : _b.user.id) && !isChatHide.value && ((_c = employee.value) === null || _c === void 0 ? void 0 : _c.visibilityInStudentDialogues) !== 'nobody';
        });
        var tooltip = ref(false);
        var hasContactInfo = computed(function () {
            if (!employee.value) {
                return false;
            }
            return employee.value.contactPhone || employee.value.contactTg || employee.value.contactVk;
        });
        var country = computed(function () {
            if (!employee.value.contactPhone)
                return;
            var clearPhone = employee.value.contactPhone.replace(/\s|\+/g, '');
            var country = getCountryByPhone(clearPhone);
            return countries.find(function (c) { return c.iso2 === country.iso2; });
        });
        var serializePhone = computed(function () {
            var e_1, _a;
            var input = employee.value.contactPhone;
            if (!input)
                return '';
            var clearPhone = input.replace(/\s|\+/g, '');
            var phoneVal = clearPhone.replace(/\D/g, '');
            var mask = getPhoneMask(clearPhone);
            var formattedPhone = '';
            var digitIndex = 0;
            if (mask) {
                try {
                    for (var mask_1 = __values(mask), mask_1_1 = mask_1.next(); !mask_1_1.done; mask_1_1 = mask_1.next()) {
                        var char = mask_1_1.value;
                        if (char === '#') {
                            formattedPhone += phoneVal[digitIndex] || '0';
                            digitIndex++;
                        }
                        else {
                            formattedPhone += char;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (mask_1_1 && !mask_1_1.done && (_a = mask_1.return)) _a.call(mask_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            else {
                formattedPhone = clearPhone;
            }
            return formattedPhone;
        });
        var getRoleTranslation = function (role) {
            var roleTranslations = {
                'Редактор школы': t('roles.schoolEditor'),
                'Преподаватель': t('roles.teacher'),
                'Редактор курсов': t('roles.courseEditor'),
                'Администратор': t('roles.admin'),
                'Владелец': t('roles.owner'),
                'Поддержка Skillspace': t('roles.skillspaceSupport')
            };
            return roleTranslations[role] || role;
        };
        var handleCopy = function () {
            clipboardCopy(employee.value.contactPhone);
            tooltip.value = true;
            setTimeout(function () {
                tooltip.value = false;
            }, 1000);
        };
        var openChat = function () {
            ChatStore.openDialogue(employee.value.user.id);
            ChatStore.show();
        };
        var handleClose = function () {
            hide.value();
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            var _component_e_dialog = _resolveComponent("e-dialog");
            var _directive_loading = _resolveDirective("loading");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                visible: _unref(visible),
                class: "modal modal-select-type",
                name: "c-employee-card",
                size: "lg",
                onClose: handleClose
            }, {
                default: _withCtx(function () { return [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(EAvatar, {
                                "color-id": _unref(employee).user.id,
                                name: _unref(employee).user.name,
                                src: _unref(employee).user.avatar || undefined,
                                class: "!w-24 !h-24 !text-4xl"
                            }, null, 8, ["color-id", "name", "src"])
                        ]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(employee).user.name), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_e_icon, {
                                class: _normalizeClass([[
                                        _unref(employee).schoolEmployeeRole.isOwner ? 'text-[#FFC671]' : 'text-primary'
                                    ], "w-4 h-4"]),
                                icon: _unref(employee).schoolEmployeeRole.icon
                            }, null, 8, ["class", "icon"]),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(getRoleTranslation(_unref(employee).schoolEmployeeRole.name)), 1)
                        ]),
                        (showGoToChat.value)
                            ? (_openBlock(), _createBlock(_component_e_button, {
                                key: 0,
                                class: "flex items-center mt-7",
                                type: "primary-alt",
                                onClick: openChat
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_e_icon, {
                                        class: "double-message",
                                        icon: "double-message"
                                    }),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('employee.writeToChat')), 1)
                                ]; }),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(employee).contactBiography)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(employee).contactBiography), 1))
                            : _createCommentVNode("", true),
                        (hasContactInfo.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_unref(employee).contactVk)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: 'https://vk.com/' + _unref(employee).contactVk,
                                        rel: "noopener noreferrer",
                                        target: "_blank"
                                    }, [
                                        _createVNode(_component_e_button, { type: "secondary" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_e_icon, {
                                                    class: "vk mr-2",
                                                    icon: "vk"
                                                }),
                                                _hoisted_10
                                            ]; }),
                                            _: 1
                                        })
                                    ], 8, _hoisted_9))
                                    : _createCommentVNode("", true),
                                (_unref(employee).contactTg)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: 'https://t.me/' + _unref(employee).contactTg,
                                        rel: "noopener noreferrer",
                                        target: "_blank"
                                    }, [
                                        _createVNode(_component_e_button, { type: "secondary" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_e_icon, {
                                                    class: "telegram mr-2",
                                                    icon: "telegram"
                                                }),
                                                _hoisted_12
                                            ]; }),
                                            _: 1
                                        })
                                    ], 8, _hoisted_11))
                                    : _createCommentVNode("", true),
                                _createVNode(ETooltip, {
                                    visible: tooltip.value,
                                    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) { return ((tooltip).value = $event); }),
                                    "tooltip-text": _unref(t)('employee.phoneCopied'),
                                    trigger: "manual",
                                    unselectable: ""
                                }, {
                                    default: _withCtx(function () { return [
                                        (serializePhone.value)
                                            ? (_openBlock(), _createBlock(_component_e_button, {
                                                key: 0,
                                                type: "secondary",
                                                onClick: handleCopy
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", _hoisted_13, [
                                                            _createElementVNode("div", _hoisted_14, [
                                                                (country.value)
                                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [
                                                                        _createElementVNode("use", {
                                                                            href: "/img/icons-bundled/flags.svg#".concat(country.value.iso2)
                                                                        }, null, 8, _hoisted_16)
                                                                    ]))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_17))
                                                            ]),
                                                            _createElementVNode("p", null, _toDisplayString(serializePhone.value), 1)
                                                        ])
                                                    ])
                                                ]; }),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]; }),
                                    _: 1
                                }, 8, ["visible", "tooltip-text"])
                            ]))
                            : _createCommentVNode("", true)
                    ])), [
                        [_directive_loading, _unref(loading)]
                    ])
                ]; }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
